export default __webpack_public_path__ + "8a69bc1cc628f9da02f0714845023a26.svg";